import { HttpMethods, RequestPerformer } from '@/api/api-requests-factory';
import { Ref } from 'vue';
import { GetTagExternalIdListRequest } from '@/api/tag-external/get-tag-external-id-list.request';

export class TagExternalApiResources {
  constructor(
    private readonly requestPerformer: RequestPerformer,
    private readonly multibrandApiHost: Ref<string>,
  ) {}

  public get getTagExternalIdListRequest(): GetTagExternalIdListRequest {
    return new GetTagExternalIdListRequest(
      this.requestPerformer,
      `${this.multibrandApiHost.value}/api/v1.0/front/tag/externalId`,
      HttpMethods.GET,
    );
  }
}
